<span
    [class.text-monotype]="useMonotypeFont"
    class="sb-number-fixed"
    [class.sb-safari]="isSafari"
>
    {{ fixedNumber$ | async }}
</span>
<span class="sb-number-animated" [class.text-monotype]="useMonotypeFont">
    <span>
        <span
            *ngFor="let section of parts$ | async; trackBy: trackByIndex"
            [class.sb-number-section]="
                section.type === 'integer' || section.type === 'fraction'
            "
            [class.sb-text-section]="
                section.type !== 'integer' && section.type !== 'fraction'
            "
            [class.sb-number-integer]="section.type === 'integer'"
            [class.sb-number-group]="section.type === 'group'"
            [class.sb-number-literal]="section.type === 'literal'"
            [class.sb-number-decimal]="section.type === 'decimal'"
            [class.sb-number-fraction]="section.type === 'fraction'"
            [class.sb-number-currency]="section.type === 'unit'"
            [class.sb-number-percent]="section.type === 'percent'"
            [style.--value]="
                section.type === 'integer' || section.type === 'fraction'
                    ? section.value
                    : null
            "
            [style.--text]="
                section.type === 'integer' || section.type === 'fraction'
                    ? null
                    : '\'' + section.value + '\''
            "
            [style.--leading-zeros]="section.leadingZeros ?? null"
        ></span>
    </span>
</span>
